const repeat: <T>(elem:T, count:number) => T[] 
  = (x,n) => n>0 ? [x, ...repeat(x,n-1)] : [];
export default repeat;
